// extracted by mini-css-extract-plugin
export default {"projectItemRoot":"projectitem_projectItemRoot__BS40U","title":"projectitem_title__5yzBp","status":"projectitem_status__o+Bij"};